import React from "react";
import "./Loader.css";

function Loader({ label = "Loading news..." }) {
  return (
    <div className="tt-loader-wrap" role="status" aria-live="polite">
      <span className="tt-loader-spinner" />
      <span className="tt-loader-label">{label}</span>
    </div>
  );
}

export default Loader;
